import React, {useState} from 'react';

import Question from '../../../../../assets/svgComponents/Question';
import ToolTipComponent from '../../toolTipComponent';

import './questionWithTooltipComponent.css';

const QuestionWithTooltipComponent = ({
  toolTipPosition = 'right',
  toolTipTxt = null,
}) => {
  const [showToolTip, setShowToolTip] = useState(false);

  const handleToolTip = () => {
    setShowToolTip(!showToolTip);
  };

  return toolTipTxt ? (
    <div className="et-n-question-with-tooltip-container">
      <div
        className="et-n-qwtc-question-icon"
        onMouseEnter={handleToolTip}
        onMouseLeave={handleToolTip}
        onClick={handleToolTip}>
        <Question />
        {showToolTip && (
          <ToolTipComponent
            toolTipPosition={toolTipPosition}
            toolTipTxt={toolTipTxt}
          />
        )}
      </div>
    </div>
  ) : null;
};

export default QuestionWithTooltipComponent;
